import { render, staticRenderFns } from "./completion-demo.vue?vue&type=template&id=d83012b8&scoped=true&"
import script from "./completion-demo.vue?vue&type=script&lang=js&"
export * from "./completion-demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83012b8",
  null
  
)

export default component.exports